import Immutable from 'immutable';
import {ReduceStore} from 'flux/utils';
import CurrentRoleActionTypes from '../actions/CurrentRoleActionTypes';
import CurrentRoleDispatcher from '../actions/CurrentRoleDispatcher';
import GlobalSharedTools from '../../../lib/GlobalSharedTools';

import UserRoleStore from './UserRoleStore';

class CurrentRoleStore extends ReduceStore {
  constructor() {
    super(CurrentRoleDispatcher);
  }

  getInitialState() {
    return { data: Immutable.OrderedMap(), callbacks: {} };
  }

  reduce(state, action) {
    switch (action.type) {
      case CurrentRoleActionTypes.SET_CURRENT_USER_ROLE:              // set current user role
        if (!action.roleKey) {
          return state;
        }

        state.data = state.data.set('currentUserRoleKey', action.roleKey);
        window.localStorage.setItem('currentUserRoleKey', action.roleKey);
        this.triggerCallbacks('change');
        return state;

      case CurrentRoleActionTypes.FIND_AND_SET_CURRENT_USER_ROLE:     // find by classId or studentId, then set current user role
        if (!action.criteria || (!action.criteria.classId && !action.criteria.studentId && !action.criteria.schoolId && !action.criteria.gradeId)) {
          return state;
        }

        let roles = UserRoleStore.getState();
        let associatName, associatObjId;
        if (action.criteria.classId) {
          associatName = "classRecord";
          associatObjId = action.criteria.classId;
        } else if (action.criteria.studentId) {
          associatName = "student";
          associatObjId = action.criteria.studentId;
        } else if (action.criteria.schoolId) {
          associatName = "school";
          associatObjId = action.criteria.schoolId;
        } else if (action.criteria.gradeId) {
          associatName = "classGrade";
          associatObjId = action.criteria.gradeId;
        }
        if (roles && roles.length > 0) {
          let index = roles.findIndex((role) => {
            return role.associatName == associatName && role.associatObj.id == associatObjId
          });
          if (index >= 0) {
            state.data = state.data.set('currentUserRoleKey', roles[index].key);
            window.localStorage.setItem('currentUserRoleKey', roles[index].key);
          }
        }
        this.triggerCallbacks('change');
        return state;

      case CurrentRoleActionTypes.DELETE_CURRENT_USER_ROLE:           // remove current user role
        state.data = state.data.delete('currentUserRoleKey');
        state.data = state.data.delete('currentUserRole');
        window.localStorage.removeItem('currentUserRoleKey');
        window.localStorage.removeItem('currentUserRole');
        this.triggerCallbacks('change');
        return state;

      case CurrentRoleActionTypes.REFRESH:                            // refresh current role
        this.triggerCallbacks('change');
        return state;

      case CurrentRoleActionTypes.CHANGE_CURRENT_USER_ROLE:                            // change current role
        state.data = state.data.set('currentUserRoleKey', action.role.key);
        state.data = state.data.set('currentUserRole', action.role);
        window.localStorage.setItem('currentUserRoleKey', action.role.key);
        //window.localStorage.setItem('currentUserRoleKey', action.role.associatName);
        window.localStorage.setItem('currentUserRole', JSON.stringify(action.role.associatObj));
        this.triggerCallbacks('change');
        return state;

      default:
        return state;
    }
  }

  getCurrentRole() {
    let roles = UserRoleStore.getState();
    let roleKey = this._state.data.get("currentUserRoleKey") ? this._state.data.get("currentUserRoleKey") : window.localStorage.getItem('currentUserRoleKey');
    let role = roles.find((role) => role.key === roleKey);

    if (role && role.associatName == 'system') {
      role.associatObj = this._state.data.get("currentUserRole") ? this._state.data.get("currentUserRole").associatObj : JSON.parse(window.localStorage.getItem('currentUserRole'));
    }

    return role;
  }

  addChangeListener(callbackFunc) {
    if (GlobalSharedTools.isFunction(callbackFunc)) {
      if ('change' in this._state.callbacks)
        this._state.callbacks['change'].push(callbackFunc);
      else
        this._state.callbacks['change'] = [callbackFunc];
    }
  }

  removeChangeListener(callbackFunc) {
    if (GlobalSharedTools.isFunction(callbackFunc) && ('change' in this._state.callbacks)) {
      let index = this._state.callbacks.change.findIndex((handler) => handler === callbackFunc);
      if (index >= 0)
        this._state.callbacks.change.splice(index, 1);
    }
  }

  triggerCallbacks(sectionName) {
    setTimeout(() => {
      if (this._state.callbacks[sectionName]) {
        this._state.callbacks[sectionName].forEach((fucntionHandler) => fucntionHandler.call());
      }
    }, 0);
  }
}

export default new CurrentRoleStore();


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/stores/CurrentRoleStore.js